import CommonHelmet from '@src/components/CommonHelmet';
import Registration from '@src/features/company/company-user/Registration';
import CompanyNoMenusLayout from '@src/layouts/company/CompanyNoMenusLayout';

function CompanyRegistration() {
  return (
    <CompanyNoMenusLayout>
      <CommonHelmet />
      <Registration />
    </CompanyNoMenusLayout>
  );
}

export default CompanyRegistration;
